import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  container: {},
  buttonsRow: {},
  row: {
    width: '100%',
    justifyContent: 'space-between',
    marginTop: 12
  },
  button: {
    marginLeft: 16,
    width: 136,
    padding: '12px 10px'
  },
  buttonRow: {
    marginTop: 16,
    width: '100%'
  },
  buttonBorder: {
    width: 136,
    padding: '12px 10px'
  },
  deliveryButton: {
    width: '100%',
    padding: '12px 00px'
  },
  staging: {
    marginTop: 24,
    marginLeft: 18
  }
})
